import { IContainer } from '../common/container/IContainer';
import { ApplicationRouterExtensions } from './ApplicationRouterExtensions';

export function routerContainer(container: IContainer): IContainer {
  container.set(ApplicationRouterExtensions, []);
  return container;
}
